import React, { FC, useEffect, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import classNames from 'classnames';
import style from './footer-icon.module.scss';
import { usePathname } from 'next/navigation';
import { BsSearch, BsXLg } from 'react-icons/bs';

import {
  ICategoryResponseV2,
  ISearchKeywordResponseV2,
} from '../../service/v2/graphql/generated/gql-api.generated';
import {
  GetCategoriesV2,
  GetSearchKeyword,
} from '../../service/v2/graphql/apiv2';

import { useSignedUrl } from '../../hooks/useSignedUrl/useSignedUrl';

import { FaChevronLeft } from 'react-icons/fa';
import LogoIcon from '../../assets/icons/LogoIcon';
import CategoryItemV2 from '../UserPreference/CategoryItemV2/CategoryItemV2';
import Link from 'next/link';
import Icon from '../../components/Icon';
import { useAppDispatch } from '../../hooks/useAppDispatch/UseAppDispatch';
import { setMobileProfileMenuStatus } from '../../store/slices/mobileMenu/MobileMenuSlice';
type Props = {
  onClick: () => void;
  setError?: (val: boolean) => void;
  imgSrc: string;
  alt: string;
  error?: boolean;
  className?: string;
};

type SearchProps = {
  isSearch: boolean;
  setIsSearch: (str: boolean) => void;
};
const FooterIcon: FC<Props> = ({
  onClick,
  imgSrc,
  alt,
  className,
  setError,
  error,
}) => {
  if (alt === 'profile' && !imgSrc.includes('profile.svg')) {
    const { url: avatarUrl } = useSignedUrl(imgSrc, []);
    return (
      <>
        {!error && avatarUrl ? (
          <Image
            loader={() => `${avatarUrl}`}
            src={`${avatarUrl}`}
            alt={alt}
            height={40}
            width={40}
            className={`${style['footer-menu__container__col__group__icon']} ${className}`}
            onClick={onClick}
            loading={'lazy'}
            onLoadingComplete={(result) => {
              if (result.naturalWidth === 0) {
                setError(true);
              }
            }}
          />
        ) : (
          <Image
            src={'/icons/profile.svg'}
            alt={alt}
            height={40}
            width={40}
            className={`${style['footer-menu__container__col__group__icon']} ${className}`}
            onClick={onClick}
            loading={'lazy'}
            onLoadingComplete={(result) => {
              if (result.naturalWidth === 0) {
                setError(true);
              }
            }}
          />
        )}
      </>
    );
  }
  return (
    <Image
      src={imgSrc}
      alt={alt}
      height={40}
      width={40}
      className={`${style['footer-menu__container__col__group__icon']} ${className}`}
      onClick={onClick}
    />
  );
};

export const FooterSearch: FC<SearchProps> = ({ isSearch, setIsSearch }) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [isBrowse, setIsBrowse] = useState<boolean>(false);
  const router = useRouter();
  const [eventData, setEventData] = useState<ISearchKeywordResponseV2 | null>();
  const [filterCategory, setFilterCategory] = useState<any>([]);
  const pathname = usePathname();
  const isHomePage = pathname === '/';
  const dispatch = useAppDispatch();
  const handleSearch = () => {
    dispatch(setMobileProfileMenuStatus(false));
    setIsSearch(!isSearch);
  };

  const handleMenuClose = () => {
    dispatch(setMobileProfileMenuStatus(false));
  };
  useEffect(() => {
    let isMounted = true;
    if (searchValue.length >= 3) {
      GetSearchKeyword({ keyword: searchValue.toLowerCase() }).then((data) => {
        if (
          isMounted &&
          data?.getSearchByKeyword &&
          data?.getSearchByKeyword.length > 0
        ) {
          setEventData(data?.getSearchByKeyword);
        }
      });
    } else {
      setEventData(null);
    }
    return () => {
      isMounted = false;
    };
  }, [searchValue]);
  useEffect(() => {
    GetCategoriesV2().then((res) => {
      setFilterCategory(res.getCategoriesV2);
    });
  }, []);
  useEffect(() => {
    setIsBrowse(!isSearch);
  }, [isSearch]);
  if (!isSearch) {
    return null;
  }
  if (!isBrowse) {
    return (
      <div
        className={classNames(style['footer-search'], {
          [style['header__search--show']]: isSearch,
        })}
      >
        <div className={style['footer-search--category']}>
          <div className={style['footer-search--category--search-bar']}>
            <div
              className={classNames(
                style['footer-search--category--home-icon']
              )}
            >
              {isHomePage ? (
                <Icon
                  onClick={() => {
                    setIsSearch(false);
                    dispatch(setMobileProfileMenuStatus(false));
                    router.push('/');
                  }}
                  icon="homefillIcon"
                  width={20}
                  height={20}
                />
              ) : (
                <Link
                  href="/"
                  onClick={() => {
                    setIsSearch(false);
                    dispatch(setMobileProfileMenuStatus(false));
                    router.push('/');
                  }}
                >
                  <Icon icon="homelineIcon" width={20} height={20} />
                </Link>
              )}
            </div>
            <div
              className={style['footer-search--category--browse']}
              onClick={() => setIsBrowse(true)}
            >
              Search
              <BsSearch size={15} />
            </div>
          </div>
          <div className={style['footer-search--category--item']}>
            {filterCategory.map((value, index) => (
              <CategoryItemV2
                description=""
                imgUrl={value.thumbnail}
                name={value.name}
                id={value.id}
                key={value.id}
                onSelectClick={(id) => {}}
                categotyTag={value?.categoryTags}
                totalView={value?.totalView ?? 0}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div
        className={classNames(style['footer-search'], {
          [style['header__search--show']]: isSearch,
        })}
      >
        <div className={classNames(style['footer-search--group'])}>
          <div
            className={classNames(style['footer-search--category--home-icon'])}
          >
            {isHomePage ? (
              <Icon
                onClick={() => {
                  setIsSearch(false);
                  dispatch(setMobileProfileMenuStatus(false));
                  router.push('/');
                }}
                icon="homefillIcon"
                width={20}
                height={20}
              />
            ) : (
              <Link
                href="/"
                onClick={() => {
                  setIsSearch(false);
                  dispatch(setMobileProfileMenuStatus(false));
                  router.push('/');
                }}
              >
                <Icon icon="homelineIcon" width={20} height={20} />
              </Link>
            )}
          </div>
          <div className={classNames(style['footer-search--group--input'])}>
            <div
              className={classNames(
                style['footer-search--group--search__icon']
              )}
            >
              <BsSearch size={15} />
            </div>
            <input
              id={'search'}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder={'Search'}
              type={'text'}
              name={'search'}
              autoComplete={'off'}
            />
            {searchValue.length > 0 && (
              <>
                <div
                  className={style['footer-search--cancel_icon']}
                  onClick={() => {
                    setSearchValue('');
                  }}
                >
                  <BsXLg size={16} />
                </div>
              </>
            )}
          </div>
        </div>

        <div className={classNames(style['footer-search--search-result'])}>
          {searchValue.length > 0 && (
            <>
              {eventData != null &&
                eventData.length > 0 &&
                eventData.map((item) => (
                  <div
                    key={item.title}
                    onClick={() => {
                      document.body.className = '';
                      setSearchValue('');
                      setEventData(null);
                      setIsSearch(false);
                      if (item.type === 'channel') {
                        router.push(`/${item.title}`);
                      }
                      if (item.type === 'event') {
                        router.push(`/${item.userId}/event/${item?.eventId}`);
                      }
                    }}
                    className={classNames(
                      style['footer-search--search-result__item'],
                      {
                        [style['footer-search--search-result__item--active']]:
                          item.title,
                        [style['footer-search--search-result__item--event']]:
                          item.type === 'event',
                      }
                    )}
                  >
                    <div
                      className={classNames(
                        style['footer-search--search-result__content'],
                        {
                          [style[
                            'footer-search--search-result__content--event'
                          ]]: item.type === 'event',
                        }
                      )}
                    >
                      {item.imgUrl ? (
                        <Image
                          src={`${process.env.NEXT_PUBLIC_ASSET_CDN}${item.imgUrl}`}
                          alt={item.title}
                          fill={true}
                          loader={(): any => {
                            return `${process.env.NEXT_PUBLIC_ASSET_CDN}${item.imgUrl}`;
                          }}
                          onLoadingComplete={(result) => {
                            if (result.naturalWidth === 0) {
                              // setImgLogoError(true);
                            }
                          }}
                          onError={(e) => {
                            // setImgLogoError(true);
                          }}
                        />
                      ) : (
                        <div
                          className={classNames(
                            style['footer-search--search-result--default-icon']
                          )}
                        >
                          <LogoIcon width={20} height={20} isThumbnail={true} />
                        </div>
                      )}
                      <div
                        className={
                          style['footer-search--search-result__content__group']
                        }
                      >
                        <div
                          className={classNames(
                            style[
                              'footer-search--search-result__content__group__title'
                            ],
                            {
                              [style[
                                'footer-search--search-result__content__group__title--event'
                              ]]: item.type === 'event',
                            }
                          )}
                        >
                          {item.title}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default FooterIcon;
